import React, { useState } from 'react';
import { Calendar as CalendarIcon, Download, Filter } from 'lucide-react';
import { AttendanceLogItem } from '../components/AttendanceLogItem';
import { EmptyState } from '../components/EmptyState';
export function HistoryPage() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  // Mock data
  const logs = [{
    id: '1',
    employeeName: 'Sarah Connor',
    timeIn: '08:58 AM',
    timeOut: '05:02 PM',
    method: 'fingerprint' as const,
    syncStatus: 'synced' as const
  }, {
    id: '2',
    employeeName: 'John Smith',
    timeIn: '09:05 AM',
    timeOut: '05:15 PM',
    method: 'face' as const,
    syncStatus: 'synced' as const
  }, {
    id: '3',
    employeeName: 'Kyle Reese',
    timeIn: '08:45 AM',
    method: 'fingerprint' as const,
    syncStatus: 'pending' as const
  }, {
    id: '4',
    employeeName: 'Marcus Wright',
    timeIn: '09:30 AM',
    method: 'face' as const,
    syncStatus: 'error' as const
  }];
  return <div className="p-4 pb-20 space-y-4" data-id="element-173">
      {/* Header */}
      <div className="flex justify-between items-center mb-2" data-id="element-174">
        <h1 className="text-2xl font-bold text-white" data-id="element-175">History</h1>
        <button className="p-2 text-slate-400 hover:text-white bg-slate-800 rounded-lg border border-slate-700" data-id="element-176">
          <Download size={20} data-id="element-177" />
        </button>
      </div>

      {/* Date Selector */}
      <div className="bg-slate-800 p-3 rounded-xl border border-slate-700 flex items-center justify-between mb-4" data-id="element-178">
        <button className="p-1 text-slate-400 hover:text-white" data-id="element-179">&lt;</button>
        <div className="flex items-center space-x-2 text-white font-medium" data-id="element-180">
          <CalendarIcon size={16} className="text-blue-400" data-id="element-181" />
          <span data-id="element-182">
            Today,{' '}
            {selectedDate.toLocaleDateString([], {
            month: 'short',
            day: 'numeric'
          })}
          </span>
        </div>
        <button className="p-1 text-slate-400 hover:text-white" data-id="element-183">&gt;</button>
      </div>

      {/* Summary Chips */}
      <div className="flex space-x-3 overflow-x-auto pb-2" data-id="element-184">
        <div className="bg-slate-800 px-3 py-1.5 rounded-lg border border-slate-700 whitespace-nowrap" data-id="element-185">
          <span className="text-slate-400 text-xs uppercase mr-2" data-id="element-186">Total</span>
          <span className="text-white font-bold" data-id="element-187">{logs.length}</span>
        </div>
        <div className="bg-yellow-500/10 px-3 py-1.5 rounded-lg border border-yellow-500/20 whitespace-nowrap" data-id="element-188">
          <span className="text-yellow-500 text-xs uppercase mr-2" data-id="element-189">
            Unsynced
          </span>
          <span className="text-yellow-400 font-bold" data-id="element-190">1</span>
        </div>
        <div className="bg-red-500/10 px-3 py-1.5 rounded-lg border border-red-500/20 whitespace-nowrap" data-id="element-191">
          <span className="text-red-500 text-xs uppercase mr-2" data-id="element-192">Errors</span>
          <span className="text-red-400 font-bold" data-id="element-193">1</span>
        </div>
      </div>

      {/* List */}
      <div className="space-y-3" data-id="element-194">
        {logs.length > 0 ? logs.map(log => <AttendanceLogItem key={log.id} record={log} data-id="element-195" />) : <EmptyState icon={<Filter size={32} data-id="element-197" />} title="No records found" description="No attendance records found for this date." data-id="element-196" />}
      </div>

      {/* Sync Action */}
      <div className="fixed bottom-20 left-4 right-4" data-id="element-198">
        <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-xl shadow-lg shadow-blue-900/20 transition-colors flex items-center justify-center space-x-2" data-id="element-199">
          <span data-id="element-200">Sync Unsynced Records (2)</span>
        </button>
      </div>
    </div>;
}